import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Maria G.',
  location: 'Austin, TX',
  text: "I had chronic migraines for 3 years. Within a week of identifying my emotional conflict, the intensity dropped by 80%. My neurologist couldn't believe it.",
  highlight: 'Migraines reduced 80%'
}, {
  name: 'Carlos R.',
  location: 'Miami, FL',
  text: 'My dermatitis disappeared in 2 weeks after working through the protocol. No cream had achieved that in 5 years.',
  highlight: 'Dermatitis eliminated'
}, {
  name: 'Laura M.',
  location: 'Denver, CO',
  text: 'I looked up my symptom, read the associated emotional conflict, and it was like someone turned on a light. Everything made sense. My chronic back pain started fading within days.',
  highlight: 'Chronic pain resolved'
}, {
  name: 'Andrew P.',
  location: 'Chicago, IL',
  text: 'Total skeptic at first. But the results speak for themselves. My digestive issues of years improved drastically in 10 days.',
  highlight: 'Digestion restored'
}, {
  name: 'Sophie T.',
  location: 'Portland, OR',
  text: 'This book should be in every home. I identified the emotional root of my insomnia and for the first time in months, I slept through the night.',
  highlight: 'Insomnia overcome'
}, {
  name: 'Robert D.',
  location: 'New York, NY',
  text: "The most striking thing was the speed. I found my symptom, did the release exercise, and within 48 hours I felt relief I hadn't felt in years.",
  highlight: 'Relief in 48 hours'
}];
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy py-20 px-6 md:px-12 relative overflow-hidden" data-id="element-88">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-bloom opacity-20 pointer-events-none" data-id="element-89"></div>

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto space-y-12 relative z-10" data-id="element-90">
        <div className="text-center space-y-4" data-id="element-91">
          <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-92">
            Real Results
          </h2>
          <p className="text-lg text-stone-400 max-w-2xl mx-auto" data-id="element-93">
            People who scanned their biology and found the emotional root of
            their pain.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-94">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-navy-light border border-teal-accent/15 rounded-lg p-6 space-y-4 hover:border-teal-accent/40 hover:cyan-glow transition-all" data-id="element-95">
              <QuoteIcon className="w-6 h-6 text-teal-accent/30" data-id="element-96" />

              <p className="text-stone-300 text-sm leading-relaxed" data-id="element-97">
                "{testimonial.text}"
              </p>

              <div className="inline-block bg-teal-accent/10 border border-teal-accent/20 px-3 py-1 rounded-full" data-id="element-98">
                <span className="text-teal-accent text-xs font-semibold uppercase tracking-wide" data-id="element-99">
                  {testimonial.highlight}
                </span>
              </div>

              <div className="flex items-center justify-between pt-2 border-t border-white/5" data-id="element-100">
                <div data-id="element-101">
                  <p className="text-white font-semibold text-sm" data-id="element-102">
                    {testimonial.name}
                  </p>
                  <p className="text-stone-500 text-xs" data-id="element-103">
                    {testimonial.location}
                  </p>
                </div>
                <div className="flex gap-0.5" data-id="element-104">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 text-amber-cta fill-amber-cta" data-id="element-105" />)}
                </div>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}